import { Directive, ElementRef } from '@angular/core'
import { DndDraggableDirective } from 'ngx-drag-drop'

@Directive({
	selector: '[lowgileDraggable]',
})
export class DraggableDirective {
	constructor(
		public dndDraggable: DndDraggableDirective,
		public elementRef: ElementRef<HTMLDivElement>,
	) {}
}
